<script lang="ts">
    import cx from 'classnames';
    import type { TMarket } from '$lib/services/market/types';

    import TopBarLogo from './TopBarLogo.svelte';
    import { getRoute } from '$lib/services/navigation';

    import VerticalNav from './VerticalNav.svelte';
    import ProductItem from './ProductItem.svelte';
    import LoginItem from './LoginItem.svelte';
    import RegistrationItem from './RegistrationItem.svelte';
    import { MARKET_SLUGS } from '$lib/services/market/slugs';
    import type { TNavItem } from './types';
    import { setContext } from 'svelte';
    import { BAR_CONTEXT } from './constants';

    export let market: TMarket;
    export let showVerticals: boolean;
    export let isLoggedIn: boolean;

    export let items: Record<string, TNavItem>;
    export let verticalItems: TNavItem[];

    setContext(BAR_CONTEXT, 'top-bar');

    $: ({ productItem, wallet, profile, moreMenuItem, loginItem, registrationItem } = items);
</script>

<div class="z-[5] mt-[var(--rg-height)] w-full tablet:sticky tablet:top-[var(--rg-height)]">
    <nav
        class={cx(
            'desktop-l:h-[var(--nav-height, 80px)] flex h-[var(--nav-height,64px)] w-full flex-nowrap items-stretch bg-purple-80 px-sm tablet:flex tablet:bg-purple-90 tablet:pl-2xl'
        )}
    >
        <div
            class={cx(
                'flex flex-1 items-center gap-2xl tablet:flex-initial',
                showVerticals ? 'justify-between' : 'justify-center'
            )}
        >
            <TopBarLogo href={getRoute('/') || '/'} size={showVerticals ? 'small' : 'large'} />
        </div>

        <div class="flex items-center justify-between tablet:flex-1 tablet:pl-2xl">
            {#if showVerticals}
                <VerticalNav items={verticalItems} />
            {/if}
            <div class="hidden flex-1 justify-end pl-sm tablet:flex">
                {#if isLoggedIn}
                    <div
                        class="gap-2 relative flex flex-1 justify-end desktop-l:absolute desktop-l:left-1/2 desktop-l:-translate-x-1/2"
                    >
                        <ProductItem item={productItem} />
                        <ProductItem item={wallet} />
                        <ProductItem item={profile} />
                    </div>
                    <ProductItem item={moreMenuItem} />
                {:else}
                    {#if market.slug !== MARKET_SLUGS.SV}
                        <div class="flex items-center">
                            <LoginItem item={loginItem} />
                        </div>
                    {/if}
                    <div class="flex items-center">
                        <RegistrationItem item={registrationItem} {market} />
                    </div>
                    <ProductItem item={moreMenuItem} />
                {/if}
            </div>
        </div>
    </nav>
</div>
